// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';
export var Pencil = createSvgIcon({ All: React.createElement(React.Fragment, null,
        React.createElement("g", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" },
            React.createElement("path", { d: "M8.9497 20L21.975 6.9749c1.3668-1.3668 1.3668-3.583 0-4.9498l-.0503-.0502c-1.3668-1.3669-3.5829-1.3669-4.9497 0L3.9497 15l5 5zM19.9498 9l-5-5M17.4498 6.5l-11 11" }),
            React.createElement("path", { d: "M8.9498 20l-8 3 3-8 5 5z" })),
        React.createElement("defs", null)), }, 'medium');
//# sourceMappingURL=Pencil.js.map